var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunctionalAnalysisSplashImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "252px",
    viewBox: "0 0 320 252",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FA-image-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FA-image-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#EFEFFF",
    x: 254,
    y: 190,
    width: 65.0617284,
    height: 62
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#E2E3E6",
    x: 0,
    y: 0,
    width: 65.0617284,
    height: 62
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 32.7078189,
    y: 16,
    width: 266.584362,
    height: 205
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(63.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-54",
    fill: "#EFEFFF",
    opacity: 0.962890625,
    transform: "translate(102.000000, 21.000000) rotate(-270.000000) translate(-102.000000, -21.000000) ",
    x: 83,
    y: -81,
    width: 38,
    height: 204
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-54",
    fill: "#DCDBFE",
    opacity: 0.962890625,
    transform: "translate(39.500000, 20.000000) rotate(-270.000000) translate(-39.500000, -20.000000) ",
    x: 35.5,
    y: -4.5,
    width: 8,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-57",
    fill: "#EFEFF2",
    transform: "translate(39.500000, 61.000000) rotate(-270.000000) translate(-39.500000, -61.000000) ",
    x: 35.5,
    y: 36.5,
    width: 8,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-60",
    fill: "#EFEFF2",
    transform: "translate(39.500000, 100.000000) rotate(-270.000000) translate(-39.500000, -100.000000) ",
    x: 35.5,
    y: 75.5,
    width: 8,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-55",
    strokeOpacity: 0.207550262,
    stroke: "#6E56DB",
    fill: "#DCDBFE",
    opacity: 0.962890625,
    transform: "translate(128.500000, 20.500000) rotate(-270.000000) translate(-128.500000, -20.500000) ",
    x: 121,
    y: 13,
    width: 15,
    height: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-58",
    stroke: "#E2E3E6",
    fill: "#F5F5F7",
    opacity: 0.962890625,
    transform: "translate(128.500000, 60.500000) rotate(-270.000000) translate(-128.500000, -60.500000) ",
    x: 121,
    y: 53,
    width: 15,
    height: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-61",
    stroke: "#E2E3E6",
    fill: "#F5F5F7",
    opacity: 0.962890625,
    transform: "translate(128.500000, 100.500000) rotate(-270.000000) translate(-128.500000, -100.500000) ",
    x: 121,
    y: 93,
    width: 15,
    height: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-56",
    strokeOpacity: 0.207550262,
    stroke: "#6E56DB",
    fill: "#DCDBFE",
    opacity: 0.962890625,
    transform: "translate(177.500000, 20.500000) rotate(-270.000000) translate(-177.500000, -20.500000) ",
    x: 170,
    y: 13,
    width: 15,
    height: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-59",
    stroke: "#E2E3E6",
    fill: "#F5F5F7",
    opacity: 0.962890625,
    transform: "translate(177.500000, 60.500000) rotate(-270.000000) translate(-177.500000, -60.500000) ",
    x: 170,
    y: 53,
    width: 15,
    height: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-62",
    stroke: "#E2E3E6",
    fill: "#F5F5F7",
    opacity: 0.962890625,
    transform: "translate(177.500000, 100.500000) rotate(-270.000000) translate(-177.500000, -100.500000) ",
    x: 170,
    y: 93,
    width: 15,
    height: 15,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    fill: "#363636",
    fillRule: "nonzero",
    points: "204 40 204 42 0 42 0 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10-Copy-3",
    fill: "#363636",
    fillRule: "nonzero",
    points: "204 0 204 2 0 2 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10-Copy",
    fill: "#363636",
    fillRule: "nonzero",
    points: "204 80 204 82 0 82 0 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10-Copy-2",
    fill: "#363636",
    fillRule: "nonzero",
    points: "204 120 204 122 0 122 0 120"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DCDBFE",
    cx: 157,
    cy: 77,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DCDBFE",
    cx: 157,
    cy: 77,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,49 C172.463973,49 185,61.536027 185,77 C185,92.463973 172.463973,105 157,105 C141.536027,105 129,92.463973 129,77 C129,61.536027 141.536027,49 157,49 Z M157,50 C142.088312,50 130,62.0883118 130,77 C130,91.9116882 142.088312,104 157,104 C171.911688,104 184,91.9116882 184,77 C184,62.0883118 171.911688,50 157,50 Z",
    id: "Oval",
    fill: "#6E56DB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.196131993,
    fill: "#6F5ACE",
    cx: 157,
    cy: 77,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,70 L162,79 L158,79 L158,84 L156,84 L156,79 L152,79 L157,70 Z",
    id: "Combined-Shape",
    fill: "#000000",
    transform: "translate(157.000000, 77.000000) rotate(-29.000000) translate(-157.000000, -77.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalAnalysisSplashImage);
export default __webpack_public_path__ + "static/media/FunctionalAnalysisSplashImage.7336a90a.svg";
export { ForwardRef as ReactComponent };